/*
 * File: ObfuscatedText.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 18, 2025 at 10:38 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import PropTypes from 'prop-types';
import reactStringReplace from 'react-string-replace';

// Constants
import { OBFUSCATE_REGEX_GROUP } from '../../../constants/base.constants';

// Styles
import * as S from './ObfuscatedText.styles';


/**
 * Component
 */

export const ObfuscatedText = ({
	children
}) => reactStringReplace(children, OBFUSCATE_REGEX_GROUP, (match, i) => (
	<S.Obfuscate key={i}>{match}</S.Obfuscate>
));


/**
 * Configuration
 */

ObfuscatedText.displayName = 'ObfuscatedText';
ObfuscatedText.propTypes = {
	className: PropTypes.string
};
ObfuscatedText.defaultProps = {
	className: null,
};
